import { Link } from 'react-router-dom';
import type { FC } from 'react';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  coverImage: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
  category: string;
}

const ArticleCard: FC<ArticleCardProps> = ({
  slug,
  title,
  excerpt,
  coverImage,
  author,
  date,
  readTime,
  tags,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.REACT_APP_NAVIGATE(`/article/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <article className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300">
      <a href={`/article/${slug}`} onClick={handleClick} className="block cursor-pointer">
        <div className="relative w-full h-48 overflow-hidden">
          <img
            src={coverImage}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            title={title}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        </div>
      </a>
      <div className="p-4">
        <div className="flex items-center gap-2 mb-2 flex-wrap">
          {tags.slice(0, 2).map((tag) => (
            <span key={tag} className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
              {tag}
            </span>
          ))}
        </div>
        <a href={`/article/${slug}`} onClick={handleClick} className="block cursor-pointer">
          <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {title}
          </h3>
        </a>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
          {excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-user-line"></i>
              {author}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              {readTime}
            </span>
          </div>
          <span>{date}</span>
        </div>
      </div>
    </article>
  );
};

export default ArticleCard;